import { useScopedTranslation } from 'application/localization/useScopedTranslation';
import { DocumentNode } from 'helpers/documents/types/documents';
import styles from './HasChangesTooltipTitle.module.scss';
import { format } from 'date-fns';
import { TextButton } from 'components/uikit/buttons/TextButton';
import { ExpiredVariableDto } from 'services/api/api-client.types';
import RefreshIcon from 'assets/icons/refresh.svg?react';

export const HasChangesTooltipTitle = (props: {
  item: DocumentNode;
  onRefreshButtonClick: (variable: ExpiredVariableDto) => void;
}) => {
  const { item, onRefreshButtonClick } = props;
  const i18n = useScopedTranslation(
    'Page.Projects.ProjectDetailsPage.FoldersTree.TreeItem',
  );

  return (
    <div className={styles.tooltipMessage}>
      {item.templateWithUpdate && (
        <>
          <div className={styles.tooltipTitle}>
            {i18n.t('template_tooltip_title')}
          </div>
          <HasChangesTooltipItem
            name={item.templateWithUpdate.name}
            dateTime={item.templateWithUpdate.auditData?.created?.date!}
          />
        </>
      )}

      {item.templateWithUpdate && item.expiredVariables?.length > 0 && (
        <div className={styles.tooltipSeparator}></div>
      )}

      {item.expiredVariables?.length > 0 && (
        <>
          <div className={styles.tooltipTitle}>
            {i18n.t('variable_tooltip_title')}
          </div>
          {item.expiredVariables?.map((e) => (
            <HasChangesTooltipItem
              key={e.variableId}
              id={e.variableId}
              name={e.variableName}
              dateTime={e.variableUpdateDate}
              refreshButton={
                <TextButton
                  className={styles.refreshVariableButton}
                  onClick={() => {
                    onRefreshButtonClick(e);
                  }}
                  icon={<RefreshIcon />}
                />
              }
            />
          ))}
        </>
      )}
    </div>
  );
};

const HasChangesTooltipItem = (props: {
  id?: number;
  name: string;
  dateTime: Date;
  refreshButton?: React.ReactElement;
}) => {
  return (
    <div className={styles.tooltipContentWrapper}>
      <div className={styles.tooltipContentMain}>
        <div className={styles.tooltipContentName}>
          {props.id && (
            <span className={styles.tooltipContentId}>{props.id}</span>
          )}
          {props.name}
        </div>
        {props.refreshButton}
      </div>
      <div className={styles.tooltipContentDate}>
        {format(props.dateTime, 'PPp')}
      </div>
    </div>
  );
};
